import React, { Component } from "react";
import TableC from "../../../basicElement/TableC";
import API_URL from "../../../../common/url";
import $ from "../../../../common/AjaxRequest";
import { Button, Icon, InputNumber, Tooltip } from "antd";
import ChangeLog from "./ChangeLog";
import FeferenceQuote from "./FeferenceQuote";
import ServiceModal from "./ServiceModal";

export default class TotalPrice extends Component {
    state = {
        data: [],
        type: "view",
        params: {},
        amountData: [],
        contentData: [],
    };

    componentDidMount() {
        const { evaluateRecordId } = this.props;
        this.setState(
            {
                params: { evaluateRecordId },
            },
            this.loadData
        );
    }

    componentWillReceiveProps(nextProps) {
        const { evaluateRecordId } = nextProps;
        this.setState(
            {
                params: { evaluateRecordId },
            },
            this.loadData
        );
    }

    loadData = () => {
        const { params: {evaluateRecordId} } = this.state
        if(!evaluateRecordId) return
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateVisitFeeData,
            data: { evaluateRecordId },
            dataType: "json",
            doneResult: (res) => {
                const { 
                    evaluateVisitQuotationList = [], 
                    serveFeePageShowList = [],
                } = (res || {});
                this.setState({
                    amountData: evaluateVisitQuotationList,
                    contentData: serveFeePageShowList,
                })
            },
        };
        $.sendRequest(options);
    };

    getAmountColumns = () => {
        const columns = [
            {
                title: "评估金额(不含税)/人民币",
                key: "evaluateContent",
                dataIndex: "evaluateContent",
                width: 280,
            },
            {
                title: "访视评估金额(不含税)/元",
                key: "evaluatePrice",
                dataIndex: "evaluatePrice",
                width: 140,
                render: (text, row) => {
                    const { tipValue, evaluateServeName } = row;
                    const isOrange = evaluateServeName == '访视服务' || evaluateServeName == '基础服务' || evaluateServeName == 'DBL服务' || evaluateServeName == '关中心服务' || evaluateServeName == '项目管理服务' || evaluateServeName == '基础协助';
                    return <div>
                        <span style={{ color: isOrange ? '#fc751d' : undefined }}>{(text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                        <Tooltip title={<span>
                        {
                            (tipValue || '').split("\n").map(el => (<p>{el}</p>))
                        }
                        </span>}>
                            <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                        </Tooltip>
                        
                    </div>;
                },
            },
            {
                title: "评估工时（小时）",
                key: "evaluateManHour",
                dataIndex: "evaluateManHour",
                width: 120,
            },
            {
                title: <div style={{display: 'flex', alignItems: 'center'}}>标准工时计算金额(不含税)/元
                    <a style={{height: 15, marginLeft: 10}} onClick={() => this.showChangeLog()}><Icon type="schedule" /></a>
                    </div>,
                key: "evaluateProposePrice",
                dataIndex: "evaluateProposePrice",
                width: 160,
                render: (text, row, index) => {
                    const { type } = this.state;
                    if(type === 'edit' && index > 1) {
                        return <InputNumber 
                                    style={{ width: '100%' }}
                                    placeholder="请输入" 
                                    precision={2}
                                    value={text}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                                    onChange={value => 
                                        this.handleChange(value, 'evaluateProposePrice', index)
                                    }
                                /> 
                    }
                    return (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
                }
            },
        ];
        return columns;
    };

    getContentColumns = () => {
        const columns = [
            {
                title: "评估内容",
                key: "evaluateContent",
                dataIndex: "evaluateContent",
                width: 280,
                render: (text, row) => {
                    const { childList } = row;
                    return text == 'SMO访视&非访视相关服务' ? <a style={{ color: '#fd9877' }} onClick={() => this.ServiceModalRef.show(childList)}>{text}</a> : text
                },
            },
            {
                title: "",
                key: "evaluatePrice",
                dataIndex: "evaluatePrice",
                width: 140,
                render: (text, row) => {
                    const { tipValue, evaluateServeName } = row;
                    const isOrange = evaluateServeName == '访视服务' || evaluateServeName == '基础服务' || evaluateServeName == 'DBL服务' || evaluateServeName == '关中心服务' || evaluateServeName == '项目管理服务' || evaluateServeName == '基础协助';
                    return <div>
                        <span style={{ color: isOrange ? '#fc751d' : undefined }}>{(text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                        <Tooltip title={<span>
                        {
                            (tipValue || '').split("\n").map(el => (<p>{el}</p>))
                        }
                        </span>}>
                            <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                        </Tooltip>
                        
                    </div>;
                },
            },
            {
                title: "",
                key: "evaluateManHour",
                dataIndex: "evaluateManHour",
                width: 120,
            },
            {
                title: "",
                key: "evaluateProposePrice",
                dataIndex: "evaluateProposePrice",
                width: 160,
                render: (text, row, index) => {
                    const { type } = this.state;
                    if(type === 'edit' && index > 1) {
                        return <InputNumber 
                                    style={{ width: '100%' }}
                                    placeholder="请输入" 
                                    precision={2}
                                    value={text}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                                    onChange={value => 
                                        this.handleChange(value, 'evaluateProposePrice', index)
                                    }
                                /> 
                    }
                    return (text || text == 0)  ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
                }
            },
        ];
        return columns;
    };

    showChangeLog = () => {
        this.ChangeLogRef.show();
    }

    handleChange = (value, key, index) => {
        const { contentData } = this.state;
        contentData[index][key] = value;
        this.setState({
            contentData: [...contentData],
        })
    }

    submit = () => {
        const { contentData, params: {evaluateRecordId} } = this.state;
        const params = {};
        contentData.map(el => {
            const { evaluateServeId, evaluateProposePrice } = el;
            if(!!evaluateServeId) {
                params[`params[${evaluateServeId}]`] = evaluateProposePrice;
            }
        })
        const options = {
            method: "POST",
            url: API_URL.evaluate.saveVisitServeFeePostPrice,
            data: { evaluateRecordId, ...params },
            dataType: "json",
            doneResult: () => {
                this.setState({
                    type: 'view',
                },this.loadData)
            },
        };
        $.sendRequest(options);
        
    }

    showFeferenceQuote = () => {
        const { record } = this.props;
        this.FeferenceQuoteRef.show(record);
    }

    render() {
        const { amountData, contentData, type, params: {evaluateRecordId}  } = this.state;
        const { showButn = true } = this.props;
        return (
            <div>
                { 
                    showButn && <div style={{marginBottom: 15, position: 'relative', left: '90%'}}>
                        <Button type="primary" onClick={this.showFeferenceQuote}>参考评估</Button>
                    </div>
                }
                <div style={{
                    minHeight: showButn ? 570 : 0
                }}>
                    <TableC
                        rowKey="rowKey"
                        data={amountData}
                        columns={this.getAmountColumns()}
                        pagination={false}
                    />
                    <TableC
                        rowKey="rowKey"
                        data={contentData}
                        columns={this.getContentColumns()}
                        pagination={false}
                    />
                    <ChangeLog
                        evaluateRecordId={evaluateRecordId}
                        ref={el => this.ChangeLogRef = el}
                    />
                    <FeferenceQuote ref={el => this.FeferenceQuoteRef = el} />
                    <ServiceModal ref={el => this.ServiceModalRef = el} />
                </div>
                {
                    showButn && <div className='Forecast_Params_footer'>
                    {
                        type === 'view'?
                        <Button 
                            type="primary"
                            onClick={() => this.setState({
                                type: 'edit',
                            })}
                        >编辑</Button> :
                        <div>
                            <Button 
                                style={{ marginRight: 20 }}
                                onClick={() => this.setState({
                                    type: 'view',
                                }, this.loadData)}
                            >取消</Button>
                            <Button 
                                type="primary"
                                onClick={this.submit}
                            >确定</Button>
                        </div>
                    }
                </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/TotalPrice.js